module.exports = __webpack_public_path__ + "img/ocop-logo.2933309d.png";